var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7099 0.00443314H2.71046C1.2144 0.00443314 0 1.17032 0 2.60663V5.39501H18.276L16.0873 2.24755C15.113 0.842277 13.4692 0 11.7099 0V0.00443314Z",
    fill: "#E0E1E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3877 34.3614H4.88991C2.18868 34.3614 0 32.2602 0 29.6668V5.40039H37.3877C40.0889 5.40039 42.2776 7.50165 42.2776 10.095V29.6624C42.2776 32.2557 40.0889 34.357 37.3877 34.357V34.3614Z",
    fill: "#E0E1E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M37.3877 5.39891H18.276L16.0873 2.25146C15.113 0.846183 13.4692 0.00390625 11.7099 0.00390625H2.71046C1.2144 0.00390625 0 1.1698 0 2.6061V9.18473H42.1806C41.742 7.02584 39.7657 5.39448 37.3877 5.39448V5.39891Z",
    fill: "#E0E1E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5466 22.5325V28.6546C26.5466 29.1599 26.1218 29.5678 25.5954 29.5678H16.4621C15.9357 29.5678 15.5109 29.1599 15.5109 28.6546V22.5325C15.5109 22.271 15.2892 22.0582 15.0168 22.0582H12.9528C12.1447 22.0582 11.7061 21.1494 12.2232 20.5554L20.2946 11.3258C20.6732 10.8914 21.3704 10.8914 21.7537 11.3258L29.825 20.5554C30.3468 21.1494 29.9035 22.0582 29.0955 22.0582H27.0315C26.759 22.0582 26.5374 22.271 26.5374 22.5325H26.5466Z",
    fill: "#6A77FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M26.5465 26.6074V28.6555C26.5465 29.1609 26.1217 29.5687 25.5953 29.5687H16.4619C15.9356 29.5687 15.5107 29.1609 15.5107 28.6555V26.6074H26.5465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.2a46a99e22ba83e98ba933c0c81d1bdb.svg";
export { ForwardRef as ReactComponent };